import { Collection, Token } from './types';

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const gray = new Collection({
  0: new Token('#FFFFFF', 'palette-gray-0'),
  50: new Token('#FCFCFD', 'palette-gray-50'),
  100: new Token('#F6F7F9', 'palette-gray-100'),
  200: new Token('#E7EAEE', 'palette-gray-200'),
  300: new Token('#D3D8DF', 'palette-gray-300'),
  400: new Token('#BEC5D0', 'palette-gray-400'),
  500: new Token('#A6B0BF', 'palette-gray-500'),
  600: new Token('#8896AA', 'palette-gray-600'),
  700: new Token('#64748B', 'palette-gray-700'),
  800: new Token('#515E71', 'palette-gray-800'),
  900: new Token('#37404D', 'palette-gray-900'),
  950: new Token('#22282F', 'palette-gray-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const blue = new Collection({
  50: new Token('#FAFBFF', 'palette-blue-50'),
  100: new Token('#F0F4FF', 'palette-blue-100'),
  200: new Token('#DBE4FF', 'palette-blue-200'),
  300: new Token('#C2D1FF', 'palette-blue-300'),
  400: new Token('#A3BAFF', 'palette-blue-400'),
  500: new Token('#85A3FF', 'palette-blue-500'),
  600: new Token('#5C85FF', 'palette-blue-600'),
  700: new Token('#144FFF', 'palette-blue-700'),
  800: new Token('#0037DB', 'palette-blue-800'),
  900: new Token('#00289E', 'palette-blue-900'),
  950: new Token('#00134D', 'palette-blue-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const yellow = new Collection({
  50: new Token('#FFFEFA', 'palette-yellow-50'),
  100: new Token('#FEFBF1', 'palette-yellow-100'),
  200: new Token('#FCF6D9', 'palette-yellow-200'),
  300: new Token('#FAEEBD', 'palette-yellow-300'),
  400: new Token('#F7E7A1', 'palette-yellow-400'),
  500: new Token('#F5E085', 'palette-yellow-500'),
  600: new Token('#F2D75F', 'palette-yellow-600'),
  700: new Token('#EFCE3F', 'palette-yellow-700'),
  800: new Token('#C6A410', 'palette-yellow-800'),
  900: new Token('#846E0B', 'palette-yellow-900'),
  950: new Token('#423705', 'palette-yellow-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const orange = new Collection({
  50: new Token('#FFFDFA', 'palette-orange-50'),
  100: new Token('#FEF9F0', 'palette-orange-100'),
  200: new Token('#FDECCE', 'palette-orange-200'),
  300: new Token('#FCE2B6', 'palette-orange-300'),
  400: new Token('#FAD38E', 'palette-orange-400'),
  500: new Token('#F9C56C', 'palette-orange-500'),
  600: new Token('#F7B23B', 'palette-orange-600'),
  700: new Token('#F59E0B', 'palette-orange-700'),
  800: new Token('#C98208', 'palette-orange-800'),
  900: new Token('#7F5305', 'palette-orange-900'),
  950: new Token('#452C03', 'palette-orange-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const green = new Collection({
  50: new Token('#FCFEFB', 'palette-green-50'),
  100: new Token('#F5FCF2', 'palette-green-100'),
  200: new Token('#DBF5D1', 'palette-green-200'),
  300: new Token('#C1EDB0', 'palette-green-300'),
  400: new Token('#A1E486', 'palette-green-400'),
  500: new Token('#7DDA58', 'palette-green-500'),
  600: new Token('#5BCC2D', 'palette-green-600'),
  700: new Token('#50B428', 'palette-green-700'),
  800: new Token('#419220', 'palette-green-800'),
  900: new Token('#2C6416', 'palette-green-900'),
  950: new Token('#1C3F0E', 'palette-green-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const purple = new Collection({
  50: new Token('#FCFAFF', 'palette-purple-50'),
  100: new Token('#F6F0FF', 'palette-purple-100'),
  200: new Token('#EBDCFE', 'palette-purple-200'),
  300: new Token('#DDC4FD', 'palette-purple-300'),
  400: new Token('#CBA6FC', 'palette-purple-400'),
  500: new Token('#BA88FB', 'palette-purple-500'),
  600: new Token('#9D57FA', 'palette-purple-600'),
  700: new Token('#6107D8', 'palette-purple-700'),
  800: new Token('#5006B2', 'palette-purple-800'),
  900: new Token('#3E048A', 'palette-purple-900'),
  950: new Token('#24034F', 'palette-purple-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const pink = new Collection({
  50: new Token('#FEFBFD', 'palette-pink-50'),
  100: new Token('#FDF2F9', 'palette-pink-100'),
  150: new Token('#E3EDFB', 'palette-pink-150'),
  200: new Token('#F9DDEF', 'palette-pink-200'),
  250: new Token('#E6E9EF', 'palette-pink-250'),
  300: new Token('#F5C7E5', 'palette-pink-300'),
  400: new Token('#EFA9D7', 'palette-pink-400'),
  500: new Token('#E986C6', 'palette-pink-500'),
  600: new Token('#E057B0', 'palette-pink-600'),
  700: new Token('#BD2386', 'palette-pink-700'),
  800: new Token('#9B1D6F', 'palette-pink-800'),
  900: new Token('#741553', 'palette-pink-900'),
  950: new Token('#490E34', 'palette-pink-950'),
});

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=4880-21704&mode=design&t=6UAj9qGTfLUmrkk2-4
 */
export const red = new Collection({
  50: new Token('#FFEBEB', 'palette-red-50'),
  100: new Token('#FDF2F2', 'palette-red-100'),
  200: new Token('#F9DDDC', 'palette-red-200'),
  300: new Token('#F6C8C6', 'palette-red-300'),
  400: new Token('#F2AFAB', 'palette-red-400'),
  500: new Token('#ED918C', 'palette-red-500'),
  600: new Token('#E66760', 'palette-red-600'),
  700: new Token('#CD2A20', 'palette-red-700'),
  800: new Token('#AC221B', 'palette-red-800'),
  900: new Token('#7C1813', 'palette-red-900'),
  950: new Token('#4F100C', 'palette-red-950'),
});
